// PayU configuration (client-safe, no crypto)
// This file can be imported in both client and server components

import { config } from "@/config/app-config";

export const payuConfig = {
  merchantKey: config.payment.payu.merchantKey,
  mode: config.payment.payu.mode,
  paymentUrl:
    config.payment.payu.mode === "production"
      ? config.payment.payu.productionUrl
      : config.payment.payu.testUrl,
};
